"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareGenesysScript = void 0;
const prepareGenesysScript = ({
  deploymentId,
  environment,
  scriptUrl
} = {}) => {
  if (!window.Genesys) {
    Object.defineProperty(window, 'Genesys', {
      writable: true,
      value: {}
    });
  }
  if (deploymentId && environment && scriptUrl) {
    window._genesysJs = 'Genesys';
    Object.defineProperty(window, 'Genesys', {
      writable: true,
      value: {
        t: Date.now(),
        c: {
          environment,
          deploymentId,
          debug: process.env.NODE_ENV !== 'production'
        }
      }
    });
    const script = document.createElement('script');
    script.src = scriptUrl;
    return script;
  }
  return null;
};
exports.prepareGenesysScript = prepareGenesysScript;
